import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';
import { formatNumber } from 'accounting-js';
import * as DF from 'fixedassets/components/detail/field';

class AssetDetailGeneral extends Component {
  render = () => (
    <Form.Section title={this.props.t('assets.section.assurance')}>
      <div className="row">
        <DF.Boolean label={'assets.fields.insurable'} value={this.props.asset.insurable} />
        <DF.Catalog
          label={'assets.fields.insuranceCarrier'}
          value={this.props.asset._insuranceCarrier}
        />
        <DF.Text label={'assets.fields.insurancePolicy'} value={this.props.asset.insurancePolicy} />
        <DF.Text
          label={'assets.fields.insurancePercent'}
          value={formatNumber(this.props.asset.insurancePercent || 0)}
        />
      </div>
    </Form.Section>
  );
}

export default translate()(AssetDetailGeneral);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/AssetDetailAssurance.js